import { Table, Collapse, UncontrolledPopover, Pagination } from 'reactstrap';
import styled from 'styled-components';

import { colors, fontSizes, fonts, device } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';
import BackgroundBox from 'shared/components/BackgroundBox';

export const NotificationWrapper = styled.div`
  @media ${device.sm} {
    display: block;
    margin-left: 0;
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
    .action-header-mobile {
      flex-direction: column-reverse;
      .w-container-search-mobile {
        width: 100% !important;
        margin-top: 10px;
      }
    }
  }
  @media ${device.md} {
    display: block;
    margin-left: 0;
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
    .w-container-search-mobile {
      width: 45% !important;
    }
  }
  @media ${device.lg} {
    display: flex;
    margin-left: 4px;
    .collapse-client-container {
      margin-left: 0;
      margin-bottom: 0;
    }
    .w-container-search-mobile {
      width: 45% !important;
    }
  }
  @media ${device.xl} {
    display: flex;
    margin-left: 0;
    .collapse-client-container {
      margin-left: 0;
      margin-bottom: 0;
    }
    .w-container-search-mobile {
      width: 30% !important;
    }
  }
  .collapse-client-container {
    height: 48px;
    width: 48px;
    border-radius: 2px;
    background-color: ${colors.white};
    box-shadow: 0 0 15px 0 ${colors.mercury};
    display: flex;
    justify-content: center;
  }
  .table-notifications {
    height: 660px;
  }
  .container-action-button {
    height: 42px;
    align-items: center;
  }
`;

export const NotificationPanelBackground = styled(BackgroundBox)`
  padding: 0;
  padding-bottom: 25px;
  font-family: ${fonts.medium};
  font-size: ${fontSizes.sm}px;
  @media ${device.sm} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.md} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.lg} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 0;
  }
  @media ${device.xl} {
    flex: 0 0 20%;
    margin-left: 0;
    margin-bottom: 0;
  }
`;
export const NotificationTableBackground = styled(BackgroundBox)`
  @media ${device.sm} {
    flex: ${({ isCollapse }) => (!isCollapse ? '0 0 75%' : '0 0 94%')};
    margin-left: 9px;
    .w-search-notification {
      width: 100%;
    }
  }
  @media ${device.md} {
    flex: ${({ isCollapse }) => (!isCollapse ? '0 0 75%' : '0 0 94%')};
    margin-left: 9px;
    .w-search-notification {
      width: 100%;
    }
  }
  @media ${device.lg} {
    flex: ${({ isCollapse }) => (!isCollapse ? '0 0 74%' : '0 0 93%')};
    margin-left: 9px;
    .w-search-notification {
      width: 100%;
    }
  }
  @media ${device.xl} {
    flex: ${({ isCollapse }) => (!isCollapse ? '0 0 75%' : '0 0 90%')};
    margin-left: 19px;
    .w-search-notification {
      width: 100%;
    }
  }
`;

export const TableNotification = styled(Table)`
  @media ${device.sm} {
    overflow-x: auto;
    display: block;
    max-width: fit-content;
    white-space: nowrap;
  }
  @media ${device.md} {
  }
  @media ${device.lg} {
  }
  @media ${device.xl} {
  }
  .action-row-communication {
    cursor: pointer;
    &:hover {
      background-color: ${colors.lightGray};
    }
  }
`;

export const NotificationCollapse = styled(Collapse)`
  height: 0 !important;
  width: 207px;
  float: right;
  position: relative;
  top: -2rem;
  svg {
    height: 13px;
    width: 13px;
  }
`;

export const NotificationCollapseBackground = styled.div`
  border-radius: 4px;
  background-color: ${colors.white};
  box-shadow: 0 0 4px 0 ${colors.lightSilverTwo};
  height: auto;
`;

export const Popover = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    .popover-body {
      padding: 0;
      width: 191px;
      text-align: center;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
  .label-icon-sort {
    height: 25px;
  }
`;

export const OptionMenu = styled.div`
  width: 100%;
  cursor: pointer;
  height: 34px;
  padding: 5px;
  padding-left: 14px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

export const H6 = styled.h6(() => ({
  paddingLeft: '12px',
  paddingTop: '15px',
}));

export const DivMenuIcon = styled.div`
  text-align: center;
  width: 30%;
`;

export const TdName = styled.td`
  width: 20%;
  cursor: pointer;
  &:hover {
    color: ${colors.suvaGrey};
  }
  .link-name-notification {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 160px;
      flex: 1 1 auto;
    }
  }
`;

export const Td = styled.td`
  width: 20%;
`;

export const TdAction = styled.td`
  width: 12%;
`;

export const OptionMenuTable = styled.div`
  pointer-events: ${({ isDisible }) => (isDisible ? 'none' : 'initial')};
  color: ${({ isDisible }) => (isDisible ? colors.lightSilver : 'initial')};
  width: 100%;
  cursor: pointer;
  height: 30px;
  padding: 0.5rem 0.75rem;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

export const PaginationTable = styled(Pagination)`
  .page-item.active .page-link {
    z-index: 3;
    color: black;
    background-color: transparent;
    border-color: transparent;
    font-weight: bold;
  }
  .page-item.disabled .page-link {
    background-color: transparent;
    border-color: transparent;
  }
`;

export const SerachNotification = styled(TextField)`
  input {
    border-radius: 2px;
    color: ${colors.suvaGrey};
    font-size: ${fontSizes.sm}px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    padding: 8px 4px;
    height: 35px;
  }
`;

export const SearchDiv = styled.div`
  width: 100%;
  padding-top: 7px;
  justify-content: space-between;
  @media ${device.sm} {
    padding-left: 0;
  }
  @media ${device.md} {
    padding-left: 0;
  }
  @media ${device.lg} {
    padding-left: 0;
  }
  @media ${device.xl} {
    padding-left: 20px;
  }
`;

export const SerachClients = styled(TextField)`
  margin-top: 6px !important;
  width: 100% !important;
  input {
    color: ${colors.gullGrey};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const Hr = styled.hr`
  margin-top: -1rem;
  @media ${device.sm} {
    width: 99%;
  }
  @media ${device.md} {
    width: 99%;
  }
  @media ${device.lg} {
    width: 90%;
  }
  @media ${device.xl} {
    width: 90%;
  }
`;

export const SerachClientsForm = styled.div`
  width: 100%;
  @media ${device.sm} {
    margin-left: -5px;
  }
  @media ${device.md} {
    margin-left: -5px;
  }
  @media ${device.lg} {
    margin-left: -5px;
  }
  @media ${device.xl} {
    margin-left: -17px;
  }
`;

export const Ul = styled.ul`
  overflow: auto;
  @media ${device.sm} {
    height: 300px;
  }
  @media ${device.md} {
    height: 300px;
  }
  @media ${device.lg} {
    height: 637px;
  }
  @media ${device.xl} {
    height: 720px;
  }
`;

export const CollapseClient = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
  @media ${device.sm} {
    margin-left: 19px;
  }
  @media ${device.md} {
    margin-left: 19px;
  }
  @media ${device.lg} {
    margin-left: 19px;
  }
  @media ${device.xl} {
    margin-left: 0;
  }
`;

export const CollapseClientRight = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
`;

export const Thead = styled.thead`
  font-family: ${fonts.black};
  font-size: ${fontSizes.xs}px;
`;

export const Tbody = styled.tbody`
  font-size: ${fontSizes.sm}px;
`;

export const TBodyTr = styled.tr`
  font-family: ${({ numAnswersUnread }) => (numAnswersUnread > 0 ? fonts.bold : fonts.default)};
`;
